export default __webpack_public_path__ + "static/media/avtar-1.cf96fefa.png";